// service_ids that support payment info output
// Mizuho: 3911, 3967 / MUFG: 4099, 4039 / GMO_AOZORA_NET: 4458
export const paymentSupportedServiceIds = [3911, 3967, 4099, 4039, 4458];
